export default __webpack_public_path__ + "static/media/Group9206.518145ce.svg";